export default function(state={},action){
    switch(action.type){
        case "GET_SIDEBAR_OPTIONS":return {...state,sidebarOptions:action.payload}
        case "GET_DETAILS_DATA" : return {...state,detailsData:action.payload}
        default:
            return state;
    }
}